"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Card = void 0;
var _definitions = require("@ppay/definitions");
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ui = require("../../../ui");
var _data = require("../data");
var _BalanceActions = require("../../BalanceActions");
var _Balance = require("./Balance");
var _excluded = ["balance", "onDepositClick", "onSendClick", "onHistoryClick"];
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var history = function history(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M15 15.5H3V13.5H15V15.5ZM15 11.5H3V9.5H15V11.5ZM15 7.5H3V5.5H15V7.5ZM0 20.5L1.5 19L3 20.5L4.5 19L6 20.5L7.5 19L9 20.5L10.5 19L12 20.5L13.5 19L15 20.5L16.5 19L18 20.5V0.5L16.5 2L15 0.5L13.5 2L12 0.5L10.5 2L9 0.5L7.5 2L6 0.5L4.5 2L3 0.5L1.5 2L0 0.5V20.5Z",
    fill: "#25253E"
  }));
};
history.defaultProps = {
  width: "18",
  height: "21",
  viewBox: "0 0 18 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var StyledCard = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-top: 20px;\n  padding: 20px 16px;\n  border: 1px solid ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.secondaryShade2;
});

// const DataPriceChangeWrapper = styled.div`
//   color: ${({ theme }) => theme.colors.tertiaryShade};
// `

var Card = function Card(_ref2) {
  var balance = _ref2.balance,
    onDepositClick = _ref2.onDepositClick,
    onSendClick = _ref2.onSendClick,
    onHistoryClick = _ref2.onHistoryClick,
    props = _objectWithoutProperties(_ref2, _excluded);
  var _useTranslation = (0, _reactI18next.useTranslation)(['libWallets', 'libCommon']),
    t = _useTranslation.t;
  var historyRef = _react.default.useRef(null);
  return /*#__PURE__*/_react.default.createElement(StyledCard, props, /*#__PURE__*/_react.default.createElement(_ui.FormGroup, {
    className: "d-flex justify-content-between"
  }, /*#__PURE__*/_react.default.createElement(_data.DataAssets, {
    ticker: balance.ticker
  }), /*#__PURE__*/_react.default.createElement("div", {
    ref: historyRef
  }, /*#__PURE__*/_react.default.createElement(_ui.RoundButton, {
    icon: /*#__PURE__*/_react.default.createElement(_ui.Svg, {
      as: history
    }),
    onClick: function onClick() {
      return onHistoryClick(balance.ticker);
    }
  })), /*#__PURE__*/_react.default.createElement(_ui.Tooltip, {
    placement: "bottom",
    target: historyRef
  }, /*#__PURE__*/_react.default.createElement(_ui.MediumSpan, {
    className: "text-nowrap"
  }, t('libWallets:history')))), /*#__PURE__*/_react.default.createElement(_ui.FormGroup, null, /*#__PURE__*/_react.default.createElement(_Balance.Balance, {
    ticker: balance.ticker,
    value: balance.value,
    fiatTicker: _definitions.Ticker.USD,
    fiatTickerValue: balance.converted
  })), /*#__PURE__*/_react.default.createElement(_BalanceActions.BalanceActions, {
    onSend: onSendClick,
    onReplenish: onDepositClick
  }));
};
exports.Card = Card;